import React from "react"
import { Box, Typography, useMediaQuery } from "@mui/material"

const MessageTranscript = ({ messages, name, email, createdAt }) => {
  // Filter out private messages
  let publicMessages = messages.filter((message) => !message.isPrivate)

  if (
    publicMessages.length > 0 &&
    publicMessages[0].is_guest === false &&
    publicMessages[0].isAgent === false
  ) {
    publicMessages = publicMessages.slice(1)
  }

  const isWideScreen = useMediaQuery("(min-width:1600px)")

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp)
    const options = {
      weekday: "short",
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    }
    return date.toLocaleDateString("en-US", options)
  }

  const formatTime = (timestamp) => {
    const date = new Date(timestamp)
    return date
      .toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .toLowerCase()
  }

  return (
    <Box width="100%">
      <Box
        sx={{
          width: "100%",
          height: "368px",
          borderRadius: "16px",
          background: "#F1F3F5",
          display: "flex",
          flexDirection: "column",
          padding: "24px",
          fontFamily: 'Inter, sans-serif',
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            height: "320px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            overflow: "auto",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <Typography
            sx={{
              color: "#061522",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "18px",
              marginBottom: "8px",
            }}
          >
            Chat transcript:
          </Typography>

          <Typography
            sx={{
              color: "#061522",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "18px",
              marginBottom: "8px",
            }}
          >
            ---------------
          </Typography>

          <Typography
            sx={{
              color: "#061522",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "18px",
              marginBottom: "4px",
            }}
          >
            Name: {name.charAt(0).toUpperCase() + name.slice(1)}
          </Typography>

          <Typography
            sx={{
              color: "#061522",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "18px",
              marginBottom: "8px",
            }}
          >
            E-mail: {email && typeof email === "string"
              ? email.toLowerCase()
              : email}
          </Typography>

          <Typography
            sx={{
              color: "#061522",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "18px",
              marginBottom: "8px",
            }}
          >
            ---------------
          </Typography>

          {publicMessages.map((message, index) => (
            <React.Fragment key={message._id}>
              <Typography
                sx={{
                  color: "#061522",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  marginBottom: "4px",
                  width: "100%",
                  wordBreak: "break-word",
                }}
              >
                {message.isAgent
                  ? message.agent?.full_name || message.sender_name || "Agent"
                  : message.sender_name || "Guest"}{" "}
                ({formatTimestamp(message.createdAt)})
              </Typography>

              <Typography
                sx={{
                  color: "#061522",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  marginBottom: "8px",
                  width: "80%",
                  wordBreak: "break-word",
                  whiteSpace: "pre-wrap",
                }}
              >
                {message.un_trimmed_content || message.content}
              </Typography>

              {index < publicMessages.length - 1 && (
                <Typography
                  sx={{
                    color: "#061522",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    marginBottom: "8px",
                  }}
                >
                  ---------------
                </Typography>
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginTop: "8px",
          width: "100%",
          boxSizing: "border-box",
          marginLeft: '8px'
        }}
      >
        <Typography
          sx={{
            color: "#061522",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
            fontFamily: '"Apercu Pro", Arial, sans-serif',
            marginRight: "12px",
          }}
        >
          {name.charAt(0).toUpperCase() + name.slice(1)}
        </Typography>

        <Typography
          sx={{
            color: "#556575",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
            fontFamily: '"Apercu Pro", Arial, sans-serif',
          }}
        >
          {formatTime(createdAt)}
        </Typography>
      </Box>
    </Box>
  )
}

export default MessageTranscript
